<template>
	<div class="chat-game-user">
		<div class="chat-game-user-search">
			<input type="datetime-local" v-model="requestParam.start_time">
			<input type="datetime-local" v-model="requestParam.end_time">
			<input type="text" v-model="requestParam.keywords" placeholder="角色名" style="width: 100px;">
			<input type="text" v-model="requestParam.role_id" placeholder="角色ID" style="width: 100px;">
			<span @click="search">搜索</span>
			<span class="chat-game-user-back" @click="goGoBack">返回</span>
		</div>
		<div class="chat-game-user-box">
			<div class="chat-game-user-wrap">
				<table class="layui-table">
				  <thead>
				    <tr>
						<th width="50">平台</th>
						<th width="80">角色id</th>
						<th>角色名</th>
						<th>游戏名</th>
						<th>区名</th>
						<th width="50">操作</th>
				    </tr> 
				  </thead>
				  <tbody v-if="userList.length > 0">
				    <tr v-for="(user,index) in userList">
					  <td>{{user.platform}}</td>
				      <td>{{user.role_id}}</td>
				      <td>{{user.role_name}}</td>
					  <td>{{user.game_name}}</td>
					  <td>{{user.area_name}}</td>
					  <td>
						  <span v-if="user.friend_id == chatUser.fans_id">已绑定</span>
						  <button v-else @click = "bUser(user.id,index)">绑定</button>
					  </td>
				    </tr>
				  </tbody>
				  <tbody v-else>
					  <tr>
						  <td colspan="8" style="text-align: center;">{{errorMsg}}</td>
					  </tr>
				  </tbody>
				</table>
			</div>
		</div>
		<div class="chat-game-user-page">
			<page-component
				:dataApi="dataApi" 
				:requestParams="requestParam" 
				@page-call="pageCall($event)" 
				key="chat-game-user-page"
				ref="ChatChatOrderPage">
			</page-component>
		</div>
	</div>
</template>

<script>
	import PageComponent from '../../../components/PageComponent.vue'
	import {getUserList,bindUser} from '../../../network/game/game.js'
	
	export default{
		name:"ChatGameUser",
		props:{
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		components:{
			PageComponent
		},
		data(){
			return {
				userList: [],
				dataApi: getUserList,
				requestParam:{
					start_time:'',
					end_time:'',
					prePage: 10,
					fans_id:0,
					keywords: '',
					role_id: ''
				},
				errorMsg: '数据请求中...'
			}
		},
		methods:{
			// 分页数据回调
			pageCall(data){
				this.userList = data
				if(data.length === 0){
					this.errorMsg = '暂无用户数据'
				}
			},
			
			// 搜索
			search(){
				this.$refs.ChatChatOrderPage.initPage()
				this.userList = []
				this.errorMsg = '数据请求中...'
			},
			
			// 绑定数据
			bUser(id,index){
				let _this = this
				CHAT_LAYER.confirm('确定绑定当前用户吗？', {
					title: '绑定提示',
					btn: ['确定', '取消'] //可以无限个按钮
				}, function(index2, layero){
					CHAT_LAYER.close(index2)
					let param = {
						friend_id: _this.chatUser.fans_id,
						id: id
					}
					bindUser(param,data=>{
						if(data === false){
							CHAT_LAYER.msg('操作失败',{icon: 2})
						}else{
							CHAT_LAYER.msg('操作成功',{icon: 1})
							_this.userList[index].friend_id = param.friend_id
						}
					})
				}, function(index2){
					//按钮【按钮二】的回调
				});
			},
			
			// 返回上一层
			goGoBack(){
				this.$emit('game-user-call','role')
			}
		},
		created() {
			this.requestParam.fans_id = this.chatUser.fans_id
		}
	}
</script>

<style>
.chat-game-user{
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: #FFFFFF;
		z-index: 12;
	}
	.chat-game-user-search{
		height: 28px;
		padding: 10px 0;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-game-user-search input{
		height: 26px;
		line-height: 26px;
		max-width: 125px;
		border: 1px solid #CCCCCC;
		padding: 0 5px;
		border-radius: 2px;
		color: #666666;
		margin-right: 3px;
	}
	.chat-game-user-search span{
		display: inline-block;
		line-height: 28px;
		padding: 0 10px;
		background-color: #009688;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 3px;
		user-select: none;
	}
	.chat-game-user-back{
		background-color: orange !important;
	}
	.chat-game-user-box{
		position: absolute;
		top: 48px;
		left: 0;
		right: 0;
		bottom: 60px;
		overflow: hidden;
	}
	.chat-game-user-box .chat-game-user-wrap{
		position: relative;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-game-user-wrap>table{
		margin: 0;
		word-break: break-all;
	}
	.chat-game-user-wrap button{
		padding: 0 10px;
		font-size: 12px;
		line-height: 22px;
		background-color: #378996;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 3px;
	}
	.chat-game-user-wrap span{
		font-size: 12px;
	}
	.chat-game-user-page{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 26px;
		padding: 17px 0;
	}
</style>
